// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3nDeD","title":"Images45_title__1i3SG","images":"Images45_images__3lKUI"};